const strengthenQuestionConstants = {
  GET_STRENGTHEN_QUESTION: 'GET_STRENGTHEN_QUESTION',
};

export default strengthenQuestionConstants;
